import "./Hero.css";

export default function HeroTemplate({ stats, onPrimaryClick, onSecondaryClick }) {
  return (
    <section id="hero" className="hero">
      <div className="hero__glow hero__glow--center" />
      <div className="hero__glow hero__glow--right" />

      <div className="hero__content">
        <p className="hero__tagline">
          Mai rapid. Mai simplu. Mai eficient.
        </p>

        <div className="hero__badge">
          <span className="glow-dot" />
          Disponibil pentru proiecte noi în România
        </div>

        <h1 className="hero__title">
          Firme mici care muncesc<br />
          <span className="hero__title-gradient">ca cele mari</span>
        </h1>

        <p className="hero__subtitle">
          Automatizăm sarcinile repetitive care îți consumă orele: Excel-uri, emailuri,
          rapoarte, sincronizări. Tu te concentrezi pe ce contează.
        </p>

        <div className="hero__ctas hero-ctas">
          <button className="btn-primary hero__cta-primary" onClick={onPrimaryClick}>
            Vreau audit gratuit
          </button>
          <button className="btn-ghost hero__cta-secondary" onClick={onSecondaryClick}>
            Vezi serviciile →
          </button>
        </div>

        <div className="hero__stats">
          {stats.map(({ value, label }) => (
            <div key={label} className="hero__stat">
              <span className="hero__stat-value">{value}</span>
              <span className="hero__stat-label">{label}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
